module.exports = {"id":"159581","name":"Oriol Riera","rating":"73","photo":"./data/images/photos/4/159581.png","club":{"name":"WS Wanderers","logo":"./data/images/clubs/WSWanderers.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OriolRiera0.json
// module id = 3299
// module chunks = 0